import React, { useEffect, useRef, useState } from "react";
import MobileHeader from "../../../../layout/DriverLayout/Header";
import { Box, Typography, useTheme } from "@mui/material";
import InfoCircle from "../../../../../media/images/icons/info-circle";
import profileImage from "../../../../../media/images/profileImage.png";
import CarTagView from "../../../../components/CarTag";
import CarTimerIcon from "../../../../../media/images/icons/car-timer";
import bigCar2 from "../../../../../media/images/icons/bigcar2.svg";
import CustomButton from "../../../../components/CustomButton";
import PlusMiniSvg from "../../../../../media/images/icons/plus-mini";
import CarCancle from "../../../../../media/images/icons/car-cancle";
import ArrowLeft from "../../../../../media/images/icons/arrow-left";
import buildingSVG from "../../../../../media/images/icons/building.svg";
import peopleSVG from "../../../../../media/images/icons/people.svg";
import profileTickSVG from "../../../../../media/images/icons/profile-tick.svg";
import clockSVG from "../../../../../media/images/icons/clock.svg";
import hourglassSVG from "../../../../../media/images/icons/hourglass.svg";
import BottomTabbar from "../../../../layout/DriverLayout/BottomTabbar";

export default function TurnDetails() {
  const divRef = useRef<HTMLDivElement>(null);

  const theme = useTheme();

  const [hasScroll, setHasScroll] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (divRef.current && divRef.current.scrollTop > 5) {
        // Do something when scrolled more than 20 pixels
        setHasScroll(true);
      } else {
        setHasScroll(false);
      }
    };

    if (divRef.current) {
      divRef.current.addEventListener("scroll", handleScroll);
    }

    return () => {
      // Cleanup: remove the event listener when the component unmounts
      if (divRef.current) {
        divRef.current.removeEventListener("scroll", handleScroll);
      }
    };
  }, []);
  return (
    <>
      <MobileHeader
        title={
          <Typography
            sx={{
              fontWeight: 600,
              color: "secondary.main",
              fontSize: 16,
            }}
          >
            اعلام حضور{" "}
          </Typography>
        }
        hasScroll={hasScroll}
      />
      <Box
        ref={divRef}
        sx={{
          flex: "1",
          overflowY: "auto",
          paddingX: "16px",
        }}
      >
        <Box
          sx={{
            marginTop: "8px",
            backgroundColor: "background.default",
            display: "flex",
            flexDirection: "column",
            gap: "8px",
            padding: "8px",
            borderStyle: "solid",
            borderColor: "info.light",
            borderWidth: "1px",
            borderRadius: "8px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "4px",
              backgroundColor: "secondary.light",
              borderRadius: "8px",
              paddingY: "4px",
            }}
          >
            <InfoCircle color={theme.palette.secondary.main} />
            <Typography
              sx={{
                color: "secondary.main",
              }}
            >
              شما یک نوبت فعال با مشخصات زیر دریافت کردید.
            </Typography>
          </Box>
          <Box
            sx={{
              //   border: "1px solid gray",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "4px",
              }}
            >
              <img
                style={{
                  width: "32px",
                  borderRadius: "50%",
                }}
                src={profileImage}
                alt=""
              />
              <Typography
                sx={{
                  color: "secondary.main",
                  fontWeight: "600",
                }}
              >
                رضا یعقوبی‌فریان پور
              </Typography>
            </Box>
            <CarTagView />
          </Box>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              backgroundColor: "primary.main",
              justifyContent: "center",
              paddingY: "8px",
              borderRadius: "8px",
              gap: "4px",
            }}
          >
            <CarTimerIcon color="#fff" />
            <Typography
              sx={{
                fontWeight: "600",
                fontSize: "16px",
                color: "#fff",
              }}
            >
              شماره نوبت شما: 300
            </Typography>
          </Box>
          <Box
            sx={{
              borderColor: "info.main",
              borderWidth: "0.5px",
              borderStyle: "solid",
              borderRadius: "10px",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "8px",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "4px",
              }}
            >
              <img src={bigCar2} alt="" />
              <Typography
                sx={{
                  fontWeight: "600",
                }}
              >
                نوع بارگیر:{" "}
              </Typography>
            </Box>
            <Typography
              sx={{
                color: "secondary.main",
                fontWeight: "600",
              }}
            >
              خاور مسقف 6 چرخ 7 تا 10 تن{" "}
            </Typography>
          </Box>
          <Box
            sx={{
              borderColor: "info.main",
              borderWidth: "0.5px",
              borderStyle: "solid",
              borderRadius: "10px",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "8px",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "4px",
              }}
            >
              <img src={buildingSVG} alt="" />
              <Typography
                sx={{
                  fontWeight: "600",
                }}
              >
                نام سالن:{" "}
              </Typography>
            </Box>
            <Typography
              sx={{
                color: "primary.main",
                fontWeight: "600",
              }}
            >
              خاور مسقف 6 چرخ 7 تا 10 تن{" "}
            </Typography>
          </Box>
          <Box
            sx={{
              borderColor: "info.main",
              borderWidth: "0.5px",
              borderStyle: "solid",
              borderRadius: "10px",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "8px",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "4px",
              }}
            >
              <img src={peopleSVG} alt="" />
              <Typography
                sx={{
                  fontWeight: "600",
                }}
              >
                تعداد رانندگان در صف:{" "}
              </Typography>
            </Box>
            <Typography
              sx={{
                color: "primary.main",
                fontWeight: "600",
              }}
            >
              500{" "}
            </Typography>
          </Box>
          <Box
            sx={{
              borderColor: "info.main",
              borderWidth: "0.5px",
              borderStyle: "solid",
              borderRadius: "10px",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "8px",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "4px",
              }}
            >
              <img src={profileTickSVG} alt="" />
              <Typography
                sx={{
                  fontWeight: "600",
                }}
              >
                موقعیت شما در صف:{" "}
              </Typography>
            </Box>
            <Typography
              sx={{
                color: "primary.main",
                fontWeight: "600",
              }}
            >
              10{" "}
            </Typography>
          </Box>
          <Box
            sx={{
              borderColor: "info.main",
              borderWidth: "0.5px",
              borderStyle: "solid",
              borderRadius: "10px",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "8px",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "4px",
              }}
            >
              <img src={clockSVG} alt="" />
              <Typography
                sx={{
                  fontWeight: "600",
                }}
              >
                تاریخ دریافت نوبت:{" "}
              </Typography>
            </Box>
            <Typography
              sx={{
                color: "primary.main",
                fontWeight: "600",
              }}
            >
              1402/12/01 - 13:25{" "}
            </Typography>
          </Box>
          <Box
            sx={{
              borderColor: "secondary.main",
              borderWidth: "0.5px",
              borderStyle: "solid",
              borderRadius: "10px",
              display: "flex",
              backgroundColor: "secondary.light",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "8px",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "4px",
              }}
            >
              <img src={hourglassSVG} alt="" />
              <Typography
                sx={{
                  color: "secondary.main",
                  fontWeight: "600",
                }}
              >
                تاریخ اعتبار نوبت:{" "}
              </Typography>
            </Box>
            <Typography
              sx={{
                color: "secondary.main",
                fontWeight: "600",
              }}
            >
              1402/12/01{" "}
            </Typography>
          </Box>
          <CustomButton
            // loading
            type="outlined"
            flexDirection="row-reverse"
            //   onClick={() => appDispatch(changeLoginType())}
            title="لغو نوبت"
            bgColor="error.light"
            textColor="error.main"
            width="100%"
            fSize="16px"
            borderColor="error.main"
            fontWeight={600}
            px="10px"
            py="12px"
            borderRadius="10px"
            color="lightStatic.main"
            icon1={<CarCancle size={22} color={theme.palette.error.main} />}
          />
          <CustomButton
            // loading
            // flexDirection="row-reverse"
            //   onClick={() => appDispatch(changeLoginType())}
            title="مشاهده و انتخاب بار"
            bgColor="secondary.main"
            width="100%"
            fSize="16px"
            fontWeight={600}
            px="10px"
            py="12px"
            borderRadius="10px"
            color="lightStatic.main"
            icon2={<ArrowLeft size={32} />}
          />
        </Box>
      </Box>
      <BottomTabbar />
    </>
  );
}
